import React from 'react'

const RealizacionBingos = () => {
    return (
        <div className='container-fluid fondotransparente4'>
            <br />
            <div className='btn-titulo'>
                <div className='botonbordeazul'>
                    <h3 className='text-white px-5 mx-5 py-3 h1'>Realización de Bingos, Rifas y Lotas</h3>
                </div>
            </div>
            <br />

            {/* REQUISITOS GENERALES */}
            <div className='contcaja'>
                <div className='cajaroja'>
                    <h2 className='titulocaja'>Requisitos Generales</h2>
                </div>
                <div className='cuerpo'>
                    <p>Para organizar Bingos, Rifas, Bingo-Rifas, Lotas, Bonos Contribución y Bonos Contribución Escolar se deberá presentar la siguiente documentación:</p>
                    <ol>
                        <li>
                            <strong>Nota de solicitud</strong> dirigida al Presidente del Instituto Provincial de Juegos de Azar de Jujuy, Lic. Walter Rolando Morales, detallando: motivo del sorteo, destino de los fondos a recaudar, cantidad de cartones, determinación del responsable a cargo del pago de impuestos, mecánica de juego y su resolución, importe, detalle de los premios, hora, lugar y fecha del sorteo. La nota debe presentarse con una antelación mínima de <strong>30 días</strong> a la realización del evento.
                        </li>
                        <li>Modelo PDF del cartón.</li>
                        <li>Copia del decreto del Instrumento Constitutivo de la Entidad.</li>
                        <li>Nómina completa de la Comisión Directiva y copia del Acta de Designación de Autoridades del período en curso. Fotocopia del DNI y constancia de CUIL o CUIT, y CUE en caso de establecimientos educativos.</li>
                        <li>Último Balance de la institución, firmado por Contador Público e intervenido por el Consejo Profesional de Ciencias Económicas.</li>
                        <li>Constancia de inscripción en la A.F.I.P. y estar al día con el pago de los tributos e impuestos a los juegos, sorteos y concursos deportivos (Ley 20.630 y modificatorias).</li>
                        <li>Presupuesto estimativo de gastos y recursos, adjuntando facturas proformas de los premios en los casos que corresponda.</li>
                        <li>Pagaré-Fianza o Aval Bancario equivalente al <strong>25%</strong> sobre el total de la emisión.</li>
                        <li>DD.JJ. de Compromiso de Pago del <strong>6%</strong> por Arancel de Juego sobre el monto de los cartones vendidos.</li>
                        <li>Modelo de contrato a suscribir con los vendedores.</li>
                        <li>Acta del Órgano Competente autorizando la realización del evento y el uso de las instalaciones.</li>
                        <li>DD.JJ. del destino de posibles utilidades.</li>
                        <li>Resultado Final Operativo del sorteo y documentación donde conste la inversión realizada.</li>
                        <li>En sorteos presenciales: presentar habilitación municipal correspondiente y autorización de los bomberos.</li>
                        <li>Indicar fecha, hora y lugar de la entrega de premios.</li>
                        <li>Inscripción UIF.</li>
                    </ol>
                    <p>
                        <strong>Asesor:</strong> Pablo Llanes &mdash; <a href="tel:3886859991">388 685-9991</a>
                    </p>
                </div>
            </div>

            <br />

            {/* QUIENES POSEEN PERSONERÍA JURÍDICA */}
            <div className='contcaja'>
                <div className='cajazul'>
                    <h2 className='titulocaja'>Quienes poseen Personería Jurídica</h2>
                </div>
                <div className='cuerpo'>
                    <p>Documentación adicional a presentar:</p>
                    <ul>
                        <li>Acta en donde conste la decisión de realizar el evento.</li>
                        <li>Nota indicando la conformación de su órgano de fiscalización o control (datos personales, domicilios y teléfonos particulares).</li>
                        <li>Certificados vigentes y actualizados de personas jurídicas, donde conste nómina de autoridades.</li>
                        <li>Última acta de designación de autoridades.</li>
                        <li>Copia del estatuto social.</li>
                        <li>Último Balance General aprobado.</li>
                    </ul>
                </div>
            </div>

            <br />

            {/* ESTABLECIMIENTOS EDUCATIVOS Y/O ENTIDADES RELIGIOSAS */}
            <div className='contcaja'>
                <div className='cajazul'>
                    <h2 className='titulocaja'>Establecimientos Educativos y/o Entidades Religiosas</h2>
                </div>
                <div className='cuerpo'>
                    <p>Documentación adicional a presentar:</p>
                    <ul>
                        <li>Copia de la Resolución de Toma de Posesión del cargo (educación) o copia del Instrumento Público donde se designa al Párroco.</li>
                        <li>Copia del DNI del Párroco a cargo de la Iglesia o Parroquia.</li>
                        <li>Acta Constitutiva de la Comisión de Padres y/o Cooperadora Escolar, mediante instrumento público y/o privado con certificación de firmas de todos sus miembros.</li>
                        <li>Acta de aprobación de llevar a cabo el evento de la Comisión de Padres y/o Cooperadora Escolar.</li>
                        <li>Nota certificando la existencia de la Comisión y/o Cooperadora, firmada por la Máxima Autoridad del Establecimiento Educativo.</li>
                    </ul>
                </div>
            </div>

            <br />

            {/* ENTIDADES SIN PERSONERÍA JURÍDICA */}
            <div className='contcaja'>
                <div className='cajazul'>
                    <h2 className='titulocaja'>Entidades sin Personería Jurídica y/o Asociaciones Simples</h2>
                </div>
                <div className='cuerpo'>
                    <p>Documentación adicional a presentar:</p>
                    <ul>
                        <li>Acta Constitutiva de la Asociación realizada por Instrumento Público o por Instrumento privado con firmas certificadas ante escribano público.</li>
                        <li>Acta donde conste la decisión de realizar el evento.</li>
                        <li>Nota informando la conformación de su Órgano de Fiscalización o control (datos personales, domicilios y teléfonos particulares). Si la asociación posee menos de 20 integrantes no se exigirá que posean Órgano de Fiscalización o control.</li>
                        <li>Cuando la Asociación Simple sea una Agrupación Carnestolendas: deberá presentar un Certificado expedido por el Municipio donde autorizan la participación en los corsos de Carnaval, firmado por autoridad competente.</li>
                        <li>Cuando la Asociación Simple sea una Comisión de ayuda: deberá presentar un Certificado de reconocimiento de la Máxima Autoridad del establecimiento al que pretenden ayudar y/o por el cual trabajan.</li>
                    </ul>
                </div>
            </div>

            <br />

            {/* REGLAMENTO */}
            <div className='contcaja'>
                <div className='cajagris'>
                    <h2 className='titulocaja'>Reglamento</h2>
                </div>
                <div className='cuerpo'>
                    <p><strong>NO AL JUEGO CLANDESTINO</strong></p>
                    <p>Del monto total a recaudar se destinará el <strong>25%</strong> a sortear en premios. Los montos y disposición de los mismos estará a cargo de la comisión organizadora.</p>
                    <p>El Sorteo final se realizará siguiendo el orden indicado en el cartón de juego. El proceso de sorteo estará sujeto al control y verificación de autoridad competente. Podrán usar o no el Bolillero del Ente Regulador, para lo cual deberán abonar el alquiler por su uso y el arancel por Fiscalización de la Autoridad Contralor.</p>
                    <p>Las Rifas podrán ser sorteadas a través de los Sorteos de la Tómbola Jujeña o Lotería Nacional.</p>
                    <ol>
                        <li>Si no abonó el cartón en su totalidad, no tendrá derecho al premio. Resultará ganador el o los cartones que marquen los diez números y estos coincidan con las bolillas extraídas, incluyendo la última bolilla cantada.</li>
                        <li><strong>Premios:</strong> Serán entregados en el lugar de sorteo, al finalizar el mismo. En caso de que haya más de un ganador en uno de los sorteos, se repartirá el premio en partes iguales. <br /><em>No podrán participar en el juego los menores de 18 años.</em></li>
                        <li>Los premios en todos los casos prescribirán a los <strong>30 días corridos</strong> del sorteo respectivo.</li>
                        <li>Los organizadores no se responsabilizan y no admitirán reclamos por extravío, pérdida, sustracción, avería, adulteración, deterioro y/o cualquier circunstancia que imposibilite la presentación material total e intacta del cartón a los efectos del cobro de premios.</li>
                        <li>Cada cartón deberá llevar nombre, apellido y número de documento de una persona solamente.</li>
                        <li>El cobro del premio se hará efectivo solamente contra la presentación del cartón que figure como ganador.</li>
                    </ol>
                </div>
            </div>

            <br />

            {/* DOCUMENTACIÓN A ENTREGAR TRAS EL SORTEO */}
            <div className='contcaja'>
                <div className='cajagris'>
                    <h2 className='titulocaja'>Documentación a Entregar Tras el Sorteo</h2>
                </div>
                <div className='cuerpo'>
                    <p>Entregar en la delegación más próxima del INPROJUY:</p>
                    <ul>
                        <li>Nota detallando la cantidad y numeración de los cartones no vendidos.</li>
                        <li>La totalidad de cartones no vendidos para su control y destrucción (solicitar acta de destrucción).</li>
                        <li>Cartones ganadores con los datos del titular.</li>
                        <li>Recibos de pago de premios, facturas, actas firmadas, etc.</li>
                    </ul>
                </div>
            </div>


            <br />
        </div>
    )
}

export default RealizacionBingos
